import guid from 'guid'

export type Guid = string

let empty: Guid = guid.EMPTY

let createNew: () => Guid = () => guid.raw() as Guid

export default { empty, createNew }